export default __webpack_public_path__ + "static/media/about.e015b13a.jpg";